export default "__VITE_ASSET__Bq5fep6p__"